import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=30577db6&scoped=true"
import script from "./Product.vue?vue&type=script&lang=ts"
export * from "./Product.vue?vue&type=script&lang=ts"
import style0 from "./Product.vue?vue&type=style&index=0&id=30577db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30577db6",
  null
  
)

export default component.exports